import { makeStyles } from "src/makeStyles";

const useStyles = makeStyles()((theme) => ({
  dialog: {
    padding: "30px"
  },
  dialogPaper: {
    borderRadius: "20px",
    padding: "0 40px"
  },
  dialogTitle: {
    margin: "20px 25px 30px",
    padding: 0,
    textAlign: "center",
    color: theme.palette.primary.main
  },
  dialogContent: {
    textAlign: "center",
    color: theme.palette.primary.main
  },
  diablogActions: {
    justifyContent: "center"
  },
  cancelButton: {
    border: `1px solid ${theme.gray500Base}`,
    margin: "10px 20px",
    height: "36px",
    background: theme.palette.common.white,
    boxShadow: "none"
  },
  confirmButton: {
    background: theme.palette.common.white,
    height: "36px",
    margin: "10px 20px",
    boxShadow: "none",
    border: `1px solid ${theme.gray500Base}`
  },
  italicText: {
    fontStyle: "italic",
    marginTop: "15px",
    fontWeight: 500
  }
}));

export default useStyles;
